import Login from "../features/auth/login.component";
import {createBrowserRouter} from "react-router-dom";
import React from "react";
import Dashboard from "../features/dashboard/Dashboard";
import PasswordRecovery from "../features/password_recovery/password-recovery.component";
import PasswordReset from "../features/password_recovery/password-reset.component";

const mainRoutes = createBrowserRouter([
    {
        path: "/",
        element: <Login></Login>
    },
    {
        path: "/password-recovery",
        element: <PasswordRecovery></PasswordRecovery>
    },
    {
        path: "/password_reset",
        element: <PasswordReset></PasswordReset>
    },
    {
        path: "/dashboard",
        element: <Dashboard></Dashboard>,
    },
]);

export default mainRoutes;
